module.exports = __webpack_public_path__ + "static/media/parallax-4.db5f33d2.jpg";